import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import type { Review } from '../../models/review.model';

@Component({
  selector: 'ess-review-list',
  templateUrl: './review-list.component.html',
  styleUrls: ['./review-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ReviewListComponent {
  @Input() reviews: Review[] = [];
  @Input() totalRating: number | null | undefined;
}
